import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Layout
import Layout from "./components/Layout";

// Public Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import MouthGuardsPage from "./pages/MouthGuardsPage";
import GalleryPage from "./pages/GalleryPage";
import CostComparisonPage from "./pages/CostComparisonPage";
import InsurancePaymentPage from "./pages/InsurancePaymentPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import ConfirmAppointmentPage from "./pages/ConfirmAppointmentPage";

// Admin Pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminRegisterPage from "./pages/admin/AdminRegisterPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminAppointments from "./pages/admin/AdminAppointments";
import AdminBlogs from "./pages/admin/AdminBlogs";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminEmailCampaigns from "./pages/admin/AdminEmailCampaigns";
import AdminAppointmentSettings from "./pages/admin/AdminAppointmentSettings";
import AdminFeatures from "./pages/admin/AdminFeatures";
import AdminLeadScoring from "./pages/admin/AdminLeadScoring";
import AdminAssets from "./pages/admin/AdminAssets";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/mouth-guards" element={<MouthGuardsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/cost-comparison" element={<CostComparisonPage />} />
            <Route path="/insurance-payment" element={<InsurancePaymentPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/confirm-appointment/:token" element={<ConfirmAppointmentPage />} />
          </Route>

          {/* Admin Auth Routes */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/register" element={<AdminRegisterPage />} />

          {/* Admin Dashboard Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="appointments" element={<AdminAppointments />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="faqs" element={<AdminFAQs />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="email-campaigns" element={<AdminEmailCampaigns />} />
            <Route path="appointment-settings" element={<AdminAppointmentSettings />} />
            <Route path="features" element={<AdminFeatures />} />
            <Route path="lead-scoring" element={<AdminLeadScoring />} />
            <Route path="assets" element={<AdminAssets />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
